import AddIcon from '@mui/icons-material/Add';

import classes from './classes.module.scss';
import Thumbnail from './Thumbnail';
import MomentsUploadModal from 'app/components/Uploads/MomentsUploadModal';
import useMomentsUploadForm from 'app/hooks/useMomentsUploadForm';

const MomentsCell = props => {
  const {
    data,
    colDef,
    showImageCount,
    imageCount,
    onImagesClick,
    showUpload,
    showUploadLabel,
    uploadJobId,
    uploadCustomerId,
    uploadStoryIds,
    onUploadStart,
    onUploadComplete,
    job,
    customer
  } = props;

  const {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  } = useMomentsUploadForm({
    onUploadStart,
    job,
    customer
  });

  let thumbnail = null;
  if (colDef.thumbnail) {
    thumbnail = <Thumbnail data={data} colDef={colDef} />;
  }

  let images = null;
  if (showImageCount) {
    images = (
      <span className={classes.gridLink} onClick={onImagesClick}>
	{imageCount}
      </span>
    );
  }

  let uploadIcon = null;
  let uploadModal = null;
  if (showUpload) {
    let uploadLabel = null;
    if (showUploadLabel) {
      uploadLabel = <span className={classes.gridIconLabel}>UPLOAD</span>;
    }

    uploadIcon = (
      <span className={classes.thumbnailLink} onClick={onAdd}>
	<AddIcon className={classes.gridIcon} />
	{uploadLabel}
      </span>
    );

    uploadModal = (
      <MomentsUploadModal
        isOpen={formIsOpen}
        onClose={onFormClose}
	onFormSubmit={onFormSubmit}
	jobId={uploadJobId}
	customerId={uploadCustomerId}
	storyIds={uploadStoryIds}
      />
    );
  }

  return (
    <div className={classes.thumbnailCell}>
      {thumbnail}
      {images}
      {uploadIcon}
      {uploadModal}
    </div>
  );
}

export default MomentsCell;
